var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.341,
    height: 188.341,
    viewBox: "0 0 188.341 188.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sad",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_418",
    "data-name": "Grupo 418",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_415",
    "data-name": "Grupo 415",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_414",
    "data-name": "Grupo 414"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_149",
    "data-name": "Elipse 149",
    cx: 94.17,
    cy: 94.17,
    r: 94.17,
    fill: "#fda043"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_421",
    "data-name": "Grupo 421",
    transform: "translate(46.63 42.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_150",
    "data-name": "Elipse 150",
    cx: 14.992,
    cy: 14.992,
    r: 14.992,
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_420",
    "data-name": "Grupo 420",
    transform: "translate(65.099)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_151",
    "data-name": "Elipse 151",
    cx: 14.992,
    cy: 14.992,
    r: 14.992,
    fill: "#634c4c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_422",
    "data-name": "Grupo 422",
    transform: "translate(39.07 89.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_586",
    "data-name": "Caminho 586",
    d: "M260.925,302.325H242.607a36.782,36.782,0,1,0-73.565,0H150.723a55.1,55.1,0,1,1,110.2,0Z",
    transform: "translate(-150.723 -247.224)",
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_587",
    "data-name": "Caminho 587",
    d: "M292.782,302.325H311.1a55.164,55.164,0,0,0-55.1-55.1h0v18.319h0A36.824,36.824,0,0,1,292.782,302.325Z",
    transform: "translate(-161.829 -157.646)",
    fill: "#634c4c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.e1899b6c6dbed79e5815c4e6b235e9e6.svg";
export { ForwardRef as ReactComponent };